<div class="button-container" #container>
  <!-- First Button Group (Left Side) -->
 
    <div class="first-group" #firstGroup>
      @if(!hideTimeLineFilter()){
      <button 
        mat-button 
        *ngFor="let option of options" 
        [class.active]="selectedOption === option"
        (click)="selectOption(option)"
      >
        {{ option }}
      </button>
    }
    </div>
 
 

  <!-- Second Button Group (Right Side) - Show buttons when multiselect is disabled -->
  <div class="second-group" #secondGroup [class.compact]="overlap" *ngIf="!useMultiselect()">
    <button
      mat-button
      [class.active]="typeOption === 'All'"
      (click)="toggleSelection('All')"
    >
      <span *ngIf="!overlap">All</span>
      <mat-icon *ngIf="overlap" [matTooltip]="'All'">select_all</mat-icon>
    </button>
    <button
      mat-button
      *ngFor="let type of types()"
      [class.active]="isSelected(type)"
      (click)="toggleSelection(type)"
    >
      <span *ngIf="!overlap">{{ type.name }}</span>
      <mat-icon *ngIf="overlap" class="filter-type-icon" [matTooltip]="type.name">{{ type.icon || 'category' }}</mat-icon>
    </button>
  </div>

  <!-- Multiselect Dropdown (Right Side) - Show when multiselect is enabled -->
  <div class="second-group multiselect-group" #secondGroupMultiselect *ngIf="useMultiselect()">
    <mat-form-field appearance="outline" floatLabel="always" class="activity-type-select">
      <mat-label>Activity Types</mat-label>
      <mat-select
        multiple
        [value]="getSelectedTypeIds()"
        (selectionChange)="onMultiselectChange($event.value)"
        placeholder="Select activity types"
      >
        <mat-option
          *ngFor="let type of types()"
          [value]="type.id"
        >
          <mat-icon class="filter-select-icon">{{ type.icon || 'category' }}</mat-icon>
          {{ type.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>